import { MedosClient } from "../../client/MedosClient";
import { ENDPOINTS } from "../../constants/endpoints";
export const PortalPackService = {
    async listPacks(addressId) {
        const client = await MedosClient.ensureInitialized();
        const res = await client.get(ENDPOINTS.portal.sessionPacks, {
            params: { addressId },
            baseURL: MedosClient.getApiBaseUrlV2(),
        });
        const raw = res.data;
        const payload = raw?.data ?? raw;
        const rows = payload?.list ?? payload?.data?.list ?? payload;
        return Array.isArray(rows) ? rows : [];
    },
    async createPatient(payload, addressId) {
        const client = await MedosClient.ensureInitialized();
        const res = await client.post(ENDPOINTS.portal.createPatient, payload, {
            params: addressId ? { addressId } : undefined,
            baseURL: MedosClient.getApiBaseUrlV2(),
        });
        const raw = res.data;
        return (raw?.data?.id ?? raw?.id) ?? null;
    },
};
